import Dialog, { DialogContent } from 'material-ui/Dialog'
import React from 'react'
import images from '../common/images'

import withStyles from 'material-ui/styles/withStyles'
import styleSheet from './AllWebChatStyle.style'

class WebChatChangeUserPlanModal extends React.Component {
  onChange(fieldName, value) {
    this.setState({ [fieldName]: value })
  }

  render() {
    const { planChangeModal, sp_charge_type, organization_plan, flag_irregular } = this.props
    const classes = this.props.classes
    return (
      <Dialog
        fullWidth={true}
        maxWidth={'sm'}
        open={planChangeModal && sp_charge_type === 0 && (!organization_plan || flag_irregular)}
        onRequestClose={() => this.props.onChange('planChangeModal', !planChangeModal)}
      >
        <DialogContent>
          <div
            className={`${classes.circle} ${classes.planModal_close}`}
            onClick={() => this.props.onChange('planChangeModal', false)}
          >
            <div>×</div>
          </div>
          <div>
            <img className={classes.planModal_img} src={images.icNurse} width={100} height={100} />
          </div>
          <div className={classes.planModal_content}>
            <h1 className={classes.planModal_title}>ご利用には有効期限内のクーポンが必要です</h1>

            <a href="/users/subscription_plan">
              <button className={`btn btn-primary ${classes.modal_priBtn}`} onClick={() => this.buyTickets()}>
                プランを変更する
              </button>
            </a>
          </div>
        </DialogContent>
      </Dialog>
    )
  }
}

export default withStyles(styleSheet)(WebChatChangeUserPlanModal)
